/**
 * Monitor - Tracks initialization state and allows waiting for completion
 * 
 * Provides a clean async/await pattern for waiting on initialization.
 * Used to ensure loggers wait for Firebase authentication before logging.
 */
export class Monitor {
  private isDone = false;
  private promise: Promise<void>;
  private resolve: (() => void) | null = null;

  constructor() {
    this.promise = new Promise<void>((res) => {
      this.resolve = res;
    });
  }

  /**
   * Wait for initialization to complete
   */
  async waitForInit(): Promise<void> {
    if (this.isDone) return Promise.resolve();
    return this.promise;
  }

  /**
   * Mark initialization as complete
   */
  done(): void {
    if (this.isDone) return;
    this.isDone = true;
    this.resolve?.();
  }

  /**
   * Check if initialization is complete
   */
  isComplete(): boolean {
    return this.isDone;
  }
}

